module.exports = __webpack_public_path__ + "img/scanTheCode.a2520244.png";